import { Route } from "react-router-dom";

import ExportPipeline from "../../exports/pages/ExportPipeline";

import Artifact from "../pages/Artifact/Artifact";
import ArtifactFiles from "../pages/Artifact/ArtifactFiles";
import ArtifactExports from "../pages/ArtifactExports";

export const artifact = (
	<Route path=":artifact" element={<Artifact />}>
		<Route index element={<ArtifactFiles />} handle={{ crumb: ({ t }) => t("files", "Files") }} />

		<Route path="exports" handle={{ crumb: ({ t }) => t("exports", "Exports") }}>
			<Route index element={<ArtifactExports />} />

			<Route
				path=":export"
				element={<ExportPipeline />}
				handle={{ crumb: ({ t }) => t("pipeline", "Pipeline") }}
			/>
		</Route>
	</Route>
);
